// Links das lojas + detecção de plataforma para o nudge "baixe o app" no login.
// Mantém os mesmos IDs usados pela API (/invite, /transfer) e pelo web-site.
export const STORE_LINKS = {
  appStore: 'https://apps.apple.com/br/app/mustauto/id6760355549',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.mustauto.app',
} as const;

export type MobilePlatform = 'ios' | 'android' | 'desktop';

// Detecta a plataforma pelo user-agent. iPadOS 13+ se reporta como Mac, então
// também checamos touch para não classificar um iPad como desktop.
export function detectMobilePlatform(): MobilePlatform {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/macintosh/.test(ua) && typeof document !== 'undefined' && 'ontouchend' in document) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'desktop';
}
